import React from 'react';
import '../styles.scss';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import Button from '../../button';

Banner.propTypes = {
    data: PropTypes.array,
    className: PropTypes.string,
};

function Banner(props) {
    const { data, className } = props;
    return (
        <div className={`page-title ${className}`}>
            <div className="icon_bg">
                <img src={require('../../../assets/images/backgroup/bg_inner_slider.png')} alt="Cerv" />
            </div>
            <div className="slider-main">
                <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={0}
                    slidesPerView={1}
                    navigation
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    loop={true}
                >
                    {
                        data.map(item => (
                            <SwiperSlide key={item.id}>
                                <div className="slider-st1">
                                    <div className="overlay">
                                        <img src={require('../../../assets/images/backgroup/bg-slider.png')} alt="Cerv" />
                                    </div>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="box-slider">
                                                    <div className="content-box">
                                                        <h1 className="title">{item.heading}</h1>
                                                        <p className="sub-title">{item.sub_heading}</p>
                                                        <div className="wrap-btn">
                                                            <Button title='VER MÁS' path={item.link} addclass='style2' />
                                                        </div>
                                                    </div>
                                                    <div className="image">
                                                        <img className="img_main" src={item.img1} alt="Cerv" />
                                                        <div className="icon icon1">
                                                            <img src={item.img2} alt="Cerv" />
                                                        </div>
                                                        <div className="icon icon2">
                                                            <img src={item.img3} alt="Cerv" />
                                                        </div>
                                                        <div className="icon icon3">
                                                            <img src={item.img4} alt="Cerv" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
        </div>
    );
}

export default Banner;